import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
import { SitePreview } from 'types/branch_feed_content'

const resource = 'browse'

export const requests = {
  fetchOgp: async (url: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<SitePreview>>(
      mergeURL(resource, 'ogp'),
      {
        params: { url },
      },
    )
  },
}
